import { render } from "./catalog.cattle.io.clusterrepo.vue?vue&type=template&id=0e407fcf"
import script from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=js"
export * from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__